const validateExpiryDate = ({ value, t }) => {
  if (!value) {
    return Promise.reject(new Error(t("trip.card.please_enter_expiry_date")))
  }

  // Check format MM/YY
  if (!/^\d{2}\/\d{2}$/.test(value)) {
    return Promise.reject(new Error(t("trip.card.format_must_be_mm_yy")))
  }

  const [month, year] = value.split("/")
  const monthNum = Number.parseInt(month, 10)
  const yearNum = Number.parseInt(year, 10)

  // Validate month (01-12)
  if (monthNum < 1 || monthNum > 12) {
    return Promise.reject(new Error(t("trip.card.month_must_be_between_01_and_12")))
  }

  // Get current date
  const now = new Date()
  const currentYear = now.getFullYear() % 100 // Get last 2 digits of current year
  const currentMonth = now.getMonth() + 1 // getMonth() returns 0-11

  // Validate year and expiry date is not in the past
  if (yearNum < currentYear) {
    return Promise.reject(new Error(t("trip.card.card_has_expired")))
  }

  if (yearNum === currentYear && monthNum < currentMonth) {
    return Promise.reject(new Error(t("trip.card.card_has_expired")))
  }

  // Validate year is not too far in the future (e.g., max 20 years from now)
  const maxYear = currentYear + 20
  if (yearNum > maxYear) {
    return Promise.reject(new Error(t("trip.card.year_cannot_be_more_than_20_years_in_the_future")))
  }

  return Promise.resolve()
}

export { validateExpiryDate }
